import { useSyncExternalStore } from 'react';

const subscribe = (query: string) => (cb: () => void) => {
    const mq = window.matchMedia(query);
    mq.addEventListener('change', cb);
    return () => mq.removeEventListener('change', cb);
};

export function useMediaQuery(query: string): boolean {
    return useSyncExternalStore(subscribe(query), () => window.matchMedia(query).matches, () => false);
}

/** Tailwind `lg` — the landscape (tablet/desktop) layout seam. */
export const useIsLandscape = () => useMediaQuery('(min-width: 1024px)');
